import { NestedHome } from '@habity/types';
// TODO: Remove all VITEC related logic from here once we have resynced all existing homes and populated the title and description fields
export const getTitle = (home: NestedHome) => {
  const { title, title_generated, provider_data, provider } = home || {};
  const { description: estateDescription } = provider_data || {};
  const { sellingHeading } = estateDescription || {};
  return provider === 'vitec' ? sellingHeading : title || title_generated || '';
};
export const getDescription = (home: NestedHome) => {
  const { description, description_generated, provider, provider_data } =
    home || {};
  const { description: estateDescription } = provider_data || {};
  const { shortSellingDescription, longSellingDescription } =
    estateDescription || {};
  const vitecDescription =
    shortSellingDescription || longSellingDescription || '';
  const userDescription = description || description_generated || '';
  
  return provider === 'vitec' ? vitecDescription : userDescription;
};